import { useState } from "react";
import ButtonComp from "../ButtonComp";
import classes from "./Banner.module.css";

export default function Banner() {
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <section className={classes.banner}>
      {/* Skeleton */}
      {!imageLoaded && <div className={classes.skeleton} />}

      {/* Background Image */}
      <img
        src="/img/home-img/home-banner-1.webp"
        alt="High-Performance IT Hardware"
        className={`${classes.bgImage} ${imageLoaded ? classes.show : classes.hide}`}
        onLoad={() => setImageLoaded(true)}
        loading="eager"
      />

      {/* Centered Content */}
      <div className={classes.content}>
        <h1 className={classes.heading}>
          High-Performance IT Hardware & Networking Solutions
        </h1>

        <p className={classes.text}>
          Prime Cloud Systems delivers premium IT hardware, servers, desktops,
          laptops, and networking equipment with fast, secure delivery across
          the USA. Build, upgrade, and optimize your IT systems with reliable,
          cost-effective solutions.
        </p>

        <ButtonComp
          link="/shop"
          text="Shop IT Solutions"
          customStyleClass={classes.homeBannerBtn}
        />
      </div>
    </section>
  );
}
